/**
 * 扩展方式：
 * 1.基础模式：扩展形式采用class、构造函数定义；
 * 2.进阶模式：扩展形式采用对象字面量{ ... }定义；
 * 3.高阶模式：扩展形式采用Function定义；
 */

import { requestRefData, setFavorite, delFavorite } from '../../utils/service';
import { awaitTo, paraseUrl, getPopupContainer } from '../../utils/tools';
import { mulLanguage } from '../../utils/formatter';

export default function (rootStore: any) {
  return {
    getRefData: {
      async doAction (rootStore: any, args: any, query: any = {}) {
        this.isOperationLog = false
        const requestData = query.requestData || { ...rootStore.referStore.getValue('requestData') }
        const params = query.params || rootStore.referStore.getValue('params')
        if (query.type === 'leftTree') {
          Object.assign(requestData, { dataType: 'tree', page: undefined, path: undefined }, requestData.treeData)
        }
        delete requestData.treeData
        if (requestData.likeValue === '') delete requestData.likeValue
        const [res, err] = await awaitTo(requestRefData({ requestData, params, props: rootStore.referInputProps }), undefined, rootStore.referInputProps)
        if (res) {
          Array.isArray(res) ? handleMulLanguage(res, rootStore.referInputProps) : handleMulLanguage(res.recordList, rootStore.referInputProps)
          return res;
        }
        return err;
      }
    },

    onDoubleClick: {
      async doAction (rootStore: any, args: any, params: any) {
        this.isOperationLog = false
        if (typeof params === 'object') { // table的双击
          if (rootStore.referInputProps.dataMultiple) {
            params.rowStore.setSelected(true)
          } else {
            rootStore.tableStore.clearMultiplePageSelectedData()
            rootStore.tableStore.setSelectRowKeys([params.rowStore.rowKey])
          }
        } else {
          if (rootStore.referInputProps.dataMultiple) {
            rootStore.treeStore.onExCheck([...new Set([...rootStore.treeStore.getCheckedKeys(), params])])
          } else {
            rootStore.treeStore.onExCheck([params])
          }
        }
        rootStore.handleOk()
        rootStore.referStore.setValue('modalVisible', false)
      }
    },

    setFavorite: {
      async doAction (rootStore: any, args: any, params: any) {
        this.isOperationLog = false
        const [res] = await awaitTo(setFavorite({ inputProps: rootStore.referInputProps, qryData: params }), undefined, rootStore.referInputProps)
        if (res.code === 200) {
          return res.data
        } else {
          console.error('setFavorite', res.message);
        }
      }
    },
    delFavorite: {
      async doAction (rootStore: any, args: any, params: any) {
        this.isOperationLog = false
        const [res] = await awaitTo(delFavorite({ qryData: params }), undefined, rootStore.referInputProps)
        if (res.code === 200) {
          return res.data || {}
        } else {
          console.error('delFavorite', res.message);
        }
      }
    },
    // pc_product--productcenter
    referAdd: {
      async doAction (rootStore: any, args: any, params: any) {
        this.isOperationLog = false
        let { cardBillno = '', pageStore, conTextQuery = {} } = rootStore.referInputProps || {};
        const [billNo, domainKey] = cardBillno.split('.')
        // cardBillno = billNo
        // domainKey = refDomain

        if (rootStore.refEntity.isMdf && billNo) {
          const obj = { ...conTextQuery, domainKey, mode: 'add' }
          window.open(`${window.location.origin}/mdf-node/meta/voucher/${billNo}?${paraseUrl(obj)}`)
        } else {
          pageStore = rootStore.pageStore || pageStore
          pageStore && pageStore.openModal({
            billNo: billNo,
            zIndex: 1700,
            params: { mode: 'add' },
            getPopupContainer: () => getPopupContainer(rootStore.referInputProps)
          }) 
        }
      }
    },
    referEdit: {
      async doAction (rootStore: any, args: any, params: any, rowStore: any) {
        this.isOperationLog = false
        let { cardBillno = '', pageStore, conTextQuery = {} } = rootStore.referInputProps || {};
        const rowKey = rowStore.rowStore.rowKey
        const [billNo, domainKey] = cardBillno.split('.')
        // cardBillno = billNo || rootStore.refEntity.cCardKe
        // domainKey = refDomain || refDomain

        if (rootStore.refEntity.isMdf && billNo) {
          const obj = { ...conTextQuery, domainKey, mode: 'edit' }
          window.open(`${window.location.origin}/mdf-node/meta/voucher/${billNo}/${rowKey}?${paraseUrl(obj)}`)
        } else {
          pageStore = rootStore.pageStore || pageStore
          pageStore && pageStore.openModal({
            billNo: billNo,
            zIndex: 1700,
            query: { billId: rowKey },
            params: { mode: 'edit' },
            getPopupContainer: () => getPopupContainer(rootStore.referInputProps)
          })
        }
      }
    }

  }
}

// 处理多语
function handleMulLanguage (data: any[], props: any) {
  data.forEach((item: any) => {
    const refReturn = typeof props.refReturn === 'string' ? [props.refReturn] : props.refReturn
    refReturn.forEach((r: string ) => {
      if (r.startsWith('$')) {
        r = r.slice(1);
      }
      item[r] = mulLanguage(item[r])
    })
  })
}
